import type { MisconceptionDefinition } from '../types'

export const GET_MACHTEN: MisconceptionDefinition[] = [
  {
    id: 'get.wortel-halveren',
    label: 'Wortel als halveren',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat √n hetzelfde is als n ÷ 2 (bv. √16 = 8 i.p.v. 4).',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.wortel-verdubbelen',
    label: 'Wortel als verdubbelen of × 2',
    module: 'Getalbegrip',
    description: 'Leerling denkt dat √n hetzelfde is als n × 2 (bv. √25 = 50).',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.wortel-kwadraat-verwarring',
    label: 'Wortel verwarren met kwadraat',
    module: 'Getalbegrip',
    description:
      'Leerling berekent het kwadraat (n × n) i.p.v. de wortel (zijn omgekeerde).',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.wortel-vergelijken-fout',
    label: 'Wortels vergelijken fout (ordening omgekeerd)',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat een groter getal onder √ een kleinere wortel geeft, of berekent niet en gokt.',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.wortel-bewerkingsfout',
    label: 'Verkeerde bewerking bij wortelteken',
    module: 'Getalbegrip',
    description:
      'Leerling past optellen, aftrekken of een andere niet-wortel-bewerking toe op het getal onder √.',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.macht-als-optellen',
    label: 'Machtsverheffen als optellen',
    module: 'Getalbegrip',
    description:
      'Leerling verwart aⁿ met a + a + … (n keer) i.p.v. a × a × … (n keer). Bv. 2³ = 6.',
    typicalFamilies: ['GET-MACHT', 'GET-MACHT-GRONDTAL'],
  },
  {
    id: 'get.macht-als-vermenigvuldigen',
    label: 'Machtsverheffen als grondtal × exponent',
    module: 'Getalbegrip',
    description:
      'Leerling rekent aⁿ als a × n i.p.v. herhaald vermenigvuldigen. Bv. 2³ = 6.',
    typicalFamilies: ['GET-MACHT', 'GET-MACHT-GRONDTAL'],
  },
  {
    id: 'get.exponent-als-grondtal',
    label: 'Grondtal en exponent verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling neemt de exponent als grondtal (of omgekeerd) bij berekening, bv. 2³ → 3 × 3 = 9.',
    typicalFamilies: ['GET-MACHT', 'GET-MACHT-GRONDTAL'],
  },
  {
    id: 'get.exponent-met-1-vermindert',
    label: 'Exponent één te laag genomen',
    module: 'Getalbegrip',
    description:
      'Leerling rekent met n − 1 i.p.v. n (vaak omdat de eerste factor "al aanwezig" wordt geteld). Bv. 2⁴ → 2³ = 8.',
    typicalFamilies: ['GET-MACHT', 'GET-MACHT-GRONDTAL'],
  },
  {
    id: 'get.hogere-exponent-altijd-groter',
    label: 'Hogere exponent altijd groter aangenomen',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat een hogere exponent altijd een grotere uitkomst geeft, ongeacht het grondtal.',
    typicalFamilies: ['GET-MACHT'],
  },
  {
    id: 'get.groter-grondtal-altijd-groter',
    label: 'Groter grondtal altijd groter aangenomen',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat een groter grondtal altijd een grotere uitkomst geeft, ongeacht de exponent.',
    typicalFamilies: ['GET-MACHT'],
  },
  {
    id: 'get.machten-niet-vergelijkbaar',
    label: 'Machten niet vergelijkbaar aangenomen',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat je machten met verschillende grondtallen of exponenten niet kunt vergelijken zonder uit te rekenen.',
    typicalFamilies: ['GET-MACHT'],
  },
  {
    id: 'get.exponent-met-1-verhoogt',
    label: 'Exponent één te hoog genomen',
    module: 'Getalbegrip',
    description:
      'Leerling rekent met n + 1 i.p.v. n (vaak omdat een extra verdubbeling/stap wordt meegeteld). Bv. 2⁴ → 2⁵ = 32.',
    typicalFamilies: ['GET-MACHT', 'GET-MACHT-GRONDTAL'],
  },
  {
    id: 'get.wortel-onder-correct',
    label: 'Wortel geschat te laag (één onder correcte gehele wortel)',
    module: 'Getalbegrip',
    description:
      'Leerling schat de wortel één lager dan correct, bv. √50 ≈ 6 i.p.v. 7 (dichtstbij).',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.wortel-eerste-cijfer',
    label: 'Eerste cijfer als wortel opgevat',
    module: 'Getalbegrip',
    description:
      'Leerling neemt het eerste cijfer van het getal onder het wortelteken als antwoord.',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.wortel-onderschat',
    label: 'Wortel onderschat (te lage gehele wortel gekozen)',
    module: 'Getalbegrip',
    description:
      'Leerling kiest een gehele wortel die te laag is voor het getal onder het wortelteken (bv. √25 → 3, √100 → 5) — de geschatte wortel is meerdere stappen te laag, los van halveren of het kwadraat.',
    typicalFamilies: ['GET-WORTEL'],
  },
  {
    id: 'get.exponent-met-1-erbij',
    label: 'Grondtal met 1 erbij i.p.v. machtsverheffen',
    module: 'Getalbegrip',
    description:
      'Leerling telt 1 op bij het grondtal in plaats van met de exponent te machtsverheffen.',
    typicalFamilies: ['GET-MACHT-GRONDTAL'],
  },
  {
    id: 'get.negatief-altijd-positief-bij-macht',
    label: 'Negatief grondtal altijd positief verondersteld',
    module: 'Getalbegrip',
    description:
      'Leerling neemt aan dat een negatief grondtal tot een macht altijd een positieve uitkomst geeft, ongeacht of de exponent even of oneven is.',
    typicalFamilies: ['GET-MACHT-GRONDTAL'],
  },
]
